module.exports = __webpack_public_path__ + "static/media/sharing-page.7bd57b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/sharing-page.png
// module id = 570
// module chunks = 0